import React, { ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";

interface ModalProps {
  children: ReactNode;
  onClose?: () => void;
  outerClasses?: string;
  innerClasses?: string;
  fullscreen?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  children,
  onClose,
  outerClasses,
  innerClasses,
  fullscreen = false,
}) => {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  const modalRoot = document.querySelector(".modal-container");
  if (!modalRoot) return null;

  const overlayClasses = twMerge(
    classNames(
      "fixed inset-0 bg-black/40 z-[1000] flex items-center justify-center",
      outerClasses
    )
  );

  const contentClasses = twMerge(
    classNames(
      fullscreen
        ? "relative w-full h-full bg-white flex items-center justify-center p-0 md:p-8"
        : "m-2 relative bg-white rounded-xl shadow-xl max-w-lg w-full p-4",
      innerClasses
    )
  );

  return ReactDOM.createPortal(
    <div
      className={overlayClasses}
      onClick={onClose}
    >
      <div
        className={contentClasses}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
